import { connect } from "react-redux"
import React, { Component } from "react"

import { evidenceAddRequest } from "../../actions/evidence-actions"
import { validateUrl } from "../../config/util-functions"
import SpinnerImage from "./SpinnerImage"

class EvidenceLinkForm extends Component {
    state = {
        link: "",
        showErrorMessage: false
    }

    handleInputChange = event => {
        this.setState({
            link: event.currentTarget.value,
            showErrorMessage: event.currentTarget.value
                ? !validateUrl(event.currentTarget.value)
                : false
        })
    }

    handleClear = event => {
        this.setState({
            link: "",
            showErrorMessage: false
        })
    }

    handleSubmit = event => {
        event.preventDefault()

        this.props.onAddEvidence(this.state.link, this.props.roleID)

        this.setState({
            link: "",
            showErrorMessage: false
        })
    }

    render() {
        const { link, showErrorMessage } = this.state

        const { isSaving } = this.props

        return (
            <form onSubmit={this.handleSubmit}>
                <input
                    autoFocus={true}
                    name="link"
                    onChange={this.handleInputChange}
                    type="text"
                    className="evidence-link-input form-control"
                    placeholder="Paste or type a link to a file or video"
                    value={link}
                    required
                    data-cy="evidenceURLInput"
                />
                <div className="evidence-link-buttons">
                    <span>
                        {showErrorMessage
                            ? "The provided url is not valid."
                            : ""}
                    </span>
                    <div>
                        {isSaving && <SpinnerImage />}
                        <button
                            className="btn btn-secondary evidence-button-clear"
                            onClick={this.handleClear}
                            type="button"
                            disabled={!link || isSaving}
                        >
                            Clear
                        </button>
                        <button
                            className="btn btn-primary"
                            type="submit"
                            disabled={!validateUrl(link) || isSaving}
                            data-cy="addEvidenceButton"
                        >
                            Add Evidence
                        </button>
                    </div>
                </div>
            </form>
        )
    }
}

const mapStateToProps = ({ presentation: { evidence } }, { roleID }) => ({
    isSaving: evidence[roleID].isSaving
})

const mapDispatchToProps = dispatch => ({
    onAddEvidence: (link, roleID) => dispatch(evidenceAddRequest(link, roleID))
})

export default connect(mapStateToProps, mapDispatchToProps)(EvidenceLinkForm)
